<div class="pend-page">
  <div class="header-card">
    <div>
      <h1>Pendências</h1>
      <p>Lista consolidada das tarefas abertas, por responsável, fase, perícia e status.</p>
    </div>
    <button type="button" class="btn-light" (click)="carregar()">Atualizar</button>
  </div>

  <div class="filters">
    <label>
      <span>Status</span>
      <select [(ngModel)]="statusFiltro">
        <option value="">Todos abertos</option>
        <option *ngFor="let s of statusOpcoes" [value]="s">{{ s }}</option>
      </select>
    </label>

    <label>
      <span>Responsável</span>
      <input [(ngModel)]="responsavelFiltro" placeholder="Filtrar responsável">
    </label>

    <label class="wide">
      <span>Pesquisar</span>
      <input [(ngModel)]="textoFiltro" placeholder="Perícia, fase, tarefa ou pendência">
    </label>
  </div>

  <div class="table-card">
    <div class="table-title">
      <h2>Pendências encontradas</h2>
      <span>{{ pendencias().length }} registro(s)</span>
    </div>

    <div class="pend-table">
      <div class="pend-head">
        <div>Data</div><div>Perícia</div><div>Etapa</div><div>Tarefa</div><div>Responsável</div><div>Status</div><div>Pendência</div>
      </div>
      <div class="pend-row" *ngFor="let t of pendencias()">
        <div>{{ t.data_prevista || '-' }}</div>
        <div>{{ nomePericia(t.pericia_id) }}</div>
        <div>{{ t.etapa }}</div>
        <div><strong>{{ t.tarefa }}</strong></div>
        <div>{{ t.responsavel || '-' }}</div>
        <div><span class="pill" [ngClass]="classeStatus(t.status)">{{ t.status }}</span></div>
        <div>{{ t.observacoes || t.resultado || '-' }}</div>
      </div>
    </div>
  </div>
</div>
